//REGISTER
export const POST_VENDOR_REGISTER = "/api/v1/auth/vendor/register";

//AFFILIATE AUTH
export const AFFILIATE_POST_VENDOR_REGISTER = "/api/v1/affiliate/register";
export const AFFILIATE_GET_CODE = "/api/v1/affiliate/register/send-code";
export const POST_AFFILIATE_LOGIN = "/api/v1/affiliate/login";
export const POST_AFFILIATE_REFRESH = "/api/v1/affiliate/refresh";

//AFFILIATE DASHBOARD
export const GET_AFFILIATE_PROFILE = "/api/v1/affiliate/profile";
export const GET_AFFILIATE_DASHBOARD = "/api/v1/affiliate/dashboard";
export const GET_AFFILIATE_ANALYTICS = "/api/v1/affiliate/analytics";
export const GET_AFFILIATE_REFERRALS = "/api/v1/affiliate/referrals";
export const GET_AFFILIATE_COMMISSIONS = "/api/v1/affiliate/commissions";
export const GET_AFFILIATE_MARKETING_MATERIALS = "/api/v1/affiliate/marketing-materials";
export const POST_AFFILIATE_GENERATE_LINK = "/api/v1/affiliate/tracking/generate";

//LOGIN
export const POST_VENDOR_LOGIN = "/api/v1/auth/vendor/login";
export const POST_FAKE_JWT_LOGIN = "/api/v1/auth/vendor/login";
export const POST_VENDOR_REFRESH_TOKEN = "/api/v1/auth/vendor/refresh";
export const POST_FAKE_PASSWORD_FORGET = "/api/v1/auth/vendor/send-password-reset-code";
export const POST_PASSWORD_RESET = "/api/v1/auth/vendor/reset-password-code";
export const GET_CODE = "/api/v1/auth/vendor/register/send-code";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//VENDOR DASHBOARD
export const GET_VENDOR_STAT = "/api/v1/vendor/stats";
export const GET_VENDOR_DASHBOARD = "/api/v1/vendor/dashboard";
export const POST_VENDOR_PROPERTIES = "/api/v1/vendor/properties";
export const GET_VENDOR_PROPERTIES_STATS = "/api/v1/vendor/properties/stats";
export const GET_TOP_SELLING_PROPERTIES = "/api/v1/vendor/properties/top-selling-properties";
export const GET_VENDOR_PROPERTIES = "/api/v1/vendor/properties";
export const GET_TOP_SELLING_ROOMS = "/api/v1/vendor/properties/best-selling-rooms";
// Active property status (no property ID required)
export const GET_VENDOR_ACTIVE_STATUS = "/api/v1/vendor/properties/active-status";

//VENDOR CREATE PROPERTY
export const POST_VENDOR_PROPERTIES_GENERAL = "/api/v1/vendor/properties";
export const POST_VENDOR_PROPERTIES_POLICIES =(propertyId:any)=> `/api/v1/vendor/properties/${propertyId}/policies`;
export const POST_VENDOR_PROPERTY_ROOMS = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/rooms`;
export const POST_VENDOR_PROPERTY_TAXES_FEES = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/taxes-fees`;
export const POST_VENDOR_PROPERTY_SERVICES = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/services`;
export const GET_VENDOR_PROPERTIES_TAXES_FEES = "/api/v1/vendor/properties/taxes-fees";
export const GET_ROOM_TYPES = "/api/v1/room-types";
export const GET_VENDOR_PROPERTIES_AMENITIES = "/api/v1/properties/amenities";
export const POST_VENDOR_PROPERTIES_AMENITIES = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/amenities`;
export const POST_VENDOR_PROPERTY_UPLOAD_IMAGES = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/upload-images`;
export const POST_VENDOR_PROPERTY_ROOM_UPLOAD_IMAGES = (propertyId:any, roomId:any) => `/api/v1/vendor/properties/${propertyId}/rooms/${roomId}/upload-images`;
export const GET_VENDOR_PROPERTY_COMPLETION_STATUS = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/completion-status`;
export const GET_VENDOR_PROPERTY_TODAY_ACTIVITY = (propertyId:any) => `/api/v1/vendor/properties/${propertyId}/today-activity`;
export const SET_ROOM_AVAILABILITY = (roomId: any) => `/api/v1/vendor/rooms/${roomId}/availability`;
export const GET_ROOM_AVAILABILITY = (roomId: any) => `/api/v1/vendor/rooms/${roomId}/availability`;
export const GET_PROPERTY_IMAGES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/images`;
export const PUT_PROPERTY_IMAGE = (propertyId: any, imageId: any) => `/api/v1/vendor/properties/${propertyId}/images/${imageId}`;
export const DELETE_PROPERTY_IMAGE = (propertyId: any, imageId: any) => `/api/v1/vendor/properties/${propertyId}/images/${imageId}`;
export const GET_PROPERTY_AMENITIES_DETAIL = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/amenities`;
export const GET_PROPERTY_ROOMS_LIST = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/rooms`;
export const GET_PROPERTY_ROOMS_AVAILABILITY = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/rooms/availability`;
export const GET_ROOM_AMENITIES_DETAIL = (roomId: any) => `/api/v1/vendor/rooms/${roomId}/amenities`;
export const GET_ROOMS_AMENITIES = "/api/v1/rooms/amenities";
export const POST_VENDOR_ROOM_AMENITIES = (roomId:any) => `/api/v1/vendor/rooms/${roomId}/amenities`;
export const GET_VENDOR_BOOKINGS = "/api/v1/vendor/bookings";
export const GET_VENDOR_PROPERTIES_POLICIES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/policies`;
export const DELETE_VENDOR_PROPERTY_ROOM = (propertyId: any, roomId: any) => `/api/vendor/properties/${propertyId}/rooms/${roomId}`;
export const PUT_VENDOR_PROFILE  = "/api/v1/auth/vendor/profile";
export const PUT_VENDOR_PASSWORD = "/api/v1/auth/vendor/password";
export const GET_VENDOR_PAYMENT = "/api/v1/auth/vendor/payment";
export const POST_VENDOR_PAYMENT = "/api/v1/auth/vendor/payment";
export const PUT_VENDOR_PAYMENT = "/api/v1/auth/vendor/payment";
export const GET_VENDOR_BOOKING = (id: number | string) => `/api/v1/vendor/bookings/${id}`;
export const POST_VENDOR_BOOKING_CANCEL = (id: any) => `/api/v1/vendor/bookings/${id}/request-cancel`;
export const POST_VENDOR_BOOKING_DATE_CHANGE = (id: any) => `/api/v1/vendor/bookings/${id}/request-date-change`;
export const POST_VENDOR_BOOKING_CONFIRM_PAY_AT_HOTEL = (id: any) => `/api/v1/vendor/bookings/${id}/confirm-pay-at-hotel-payment`;
export const GET_VENDOR_PROPERTY_SERVICE_TYPES = "/api/v1/vendor/properties/services/types";

//VENDOR UPDATE (PUT) ENDPOINTS
export const GET_VENDOR_PROPERTY = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}`;
export const PUT_VENDOR_PROPERTY = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}`;
export const PUT_VENDOR_PROPERTIES_POLICIES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/policies`;
export const PUT_VENDOR_PROPERTIES_AMENITIES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/amenities`;
export const PUT_VENDOR_PROPERTY_SERVICES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/services`;
export const PUT_VENDOR_PROPERTY_TAXES_FEES = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/taxes-fees`;
export const PUT_VENDOR_PROPERTY_ROOM = (propertyId: any, roomId: any) => `/api/v1/vendor/properties/${propertyId}/rooms/${roomId}`;
export const PUT_VENDOR_ROOM_AMENITIES = (roomId: any) => `/api/v1/vendor/rooms/${roomId}/amenities`;
export const POST_VENDOR_PROPERTY_CONTRACT = (propertyId: any) => `/api/v1/vendor/properties/${propertyId}/contract`;

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";




//PROFILE
export const GET_USER_PROFILE = "/api/v1/user/profile";
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";
export const UNREAD_MAIL = "/unread/mail";
export const STARED_MAIL = "/stared/mail";
export const LABEL_MAIL = "/label/mail";
export const TRASH_MAIL = "/trash/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/product";
export const DELETE_PRODUCT = "/delete/product";
export const ADD_NEW_PRODUCT = "/add/product";
export const UPDATE_PRODUCT = "/update/product";

// Orders
export const GET_ORDERS = "/order";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/ticket";
export const ADD_NEW_TICKET = "/add/ticket";
export const UPDATE_TICKET = "/update/ticket";
export const DELETE_TICKET = "/delete/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA = "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";


// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";
export const ADD_NEW_APPLICATION_LIST = "/add/application-list";
export const UPDATE_APPLICATION_LIST = "/update/application-list";
export const DELETE_APPLICATION_LIST = "/delete/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// CANDIDATE LIST
export const GET_CANDIDATE = "/candidates";
export const ADD_NEW_CANDIDATE = "add/candidates";
export const UPDATE_CANDIDATE = "update/candidates";
export const DELETE_CANDIDATE = "delete/candidates"

export const GET_CANDIDATE_GRID = "/category-grid";
export const ADD_CANDIDATE_GRID = "/add/category-grid";

export const GET_CATEGORY_LIST = "/category-list";
export const ADD_CATEGORY_LIST = "/add/category-list";

// ==================== Admin API ====================
export const POST_ADMIN_LOGIN = "/api/v1/auth/admin/login";
export const POST_ADMIN_REFRESH = "/api/v1/auth/admin/refresh";
export const GET_ADMIN_PROFILE = "/api/v1/auth/admin/profile";
export const PUT_ADMIN_PROFILE = "/api/v1/auth/admin/profile";
export const GET_ADMIN_DASHBOARD = "/api/v1/admin/dashboard";
export const GET_ADMIN_STATS = "/api/v1/admin/stats";
export const GET_ADMIN_PROPERTIES = "/api/v1/admin/properties";
export const PUT_ADMIN_PROPERTY_APPROVE = (propertyId: any) => `/api/v1/admin/properties/${propertyId}/approve`;
export const PUT_ADMIN_PROPERTY_REJECT = (propertyId: any) => `/api/v1/admin/properties/${propertyId}/reject`;
export const PUT_ADMIN_PROPERTY_DEACTIVATE = (propertyId: any) => `/api/v1/admin/properties/${propertyId}/deactivate`;
export const PUT_ADMIN_PROPERTY_STATUS = (propertyId: any) => `/api/v1/admin/properties/${propertyId}/status`;
export const GET_ADMIN_BOOKINGS = "/api/v1/admin/bookings";
export const PUT_ADMIN_BOOKING_CANCEL = (bookingId: any) => `/api/v1/admin/bookings/${bookingId}/cancel`;
export const GET_ADMIN_VENDORS = "/api/v1/admin/vendors";
export const GET_ADMIN_VENDOR = (vendorId: any) => `/api/v1/admin/vendors/${vendorId}`;
export const PUT_ADMIN_VENDOR_APPROVE = (vendorId: any) => `/api/v1/admin/vendors/${vendorId}/approve`;
export const PUT_ADMIN_VENDOR_REJECT = (vendorId: any) => `/api/v1/admin/vendors/${vendorId}/reject`;
export const PUT_ADMIN_VENDOR_SUSPEND = (vendorId: any) => `/api/v1/admin/vendors/${vendorId}/suspend`;
export const GET_ADMIN_PROPERTY_REVIEW = (propertyId: any) => `/api/v1/admin/properties/${propertyId}/review`;
